/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StripeTransactionType {
    PURCHASE = 'purchase',
}
